import { z } from "zod";

import http from "@/services/http";

const userListParams = z.object({
  type: z.string().nullable(),
  content_id: z.number().nullish(),
  content_guid: z.string().nullish(),
  deleted_at: z.string().nullish(),
});

export type ContentParams = z.infer<typeof userListParams>;

// GET /myList (profile-service) - dto.Result{data: []dto.UserList, metadata}. Data can be null
// (var userList []dto.UserList is left nil on the early "no results" return path).
const userListItem = z
  .object({
    id: z.number(),
    content_id: z.number(),
    content_guid: z.string().nullish(),
    type: z.string(),
  })
  .loose();

const userListMetadata = z
  .object({
    current_page: z.number(),
    total_pages: z.number(),
    total_count: z.number(),
    per: z.number(),
  })
  .loose();

export const userListResponse = z
  .object({
    data: z.array(userListItem).nullish(),
    metadata: userListMetadata,
  })
  .loose();

export function add(content: ContentParams) {
  if (!content.content_id && !content.content_guid) return;

  return http().post(`${globalThis.env.API_PROFILE}/myList`, {
    UserList: userListParams.parse(content),
  });
}

export async function fetch(page: number) {
  const { data } = await http().get(`${globalThis.env.API_PROFILE}/myList`, {
    params: { per: 50, ...(page > 1 ? { page } : {}) },
  });

  return userListResponse.parse(data);
}

export async function fetchByType(type: string) {
  const { data } = await http().get(`${globalThis.env.API_PROFILE}/myList`, {
    params: { per: 50, ...(type ? { type } : {}) },
  });

  return userListResponse.parse(data);
}

const removeParams = z.object({
  content_id: z.union([z.string(), z.number()]).nullish(),
  type: z.string().nullish(),
});

export async function remove(params: z.infer<typeof removeParams>) {
  if (Number.isNaN(Number(params.content_id))) return;
  await http().delete(`${globalThis.env.API_PROFILE}/myList/${params.content_id}`, {
    data: { type: params.type },
  });
}
